import * as z from 'zod';

export const CeilingHeightSchema = z.enum([
  'lt-12-inch',
  '12-to-30-inch',
  'gt-30-inch',
]);
export type CeilingHeight = z.infer<typeof CeilingHeightSchema>;

export const SurfaceTypeSchema = z.enum([
  'open',
  'drywall',
  't-bar',
  'q-deck',
  'soffit',
  'concrete',
  'wood',
  'ceiling-tiles',
]);
export type SurfaceType = z.infer<typeof SurfaceTypeSchema>;

export const ControlsSchema = z.enum([
  'breaker',
  'switch',
  'occ_sensor',
  'dimmer',
  'low_voltage',
  'BAS',
  'daylight_sensor',
  'timer',
]);
export type Controls = z.infer<typeof ControlsSchema>;

export const AuditLightingCountFormEntrySchema = z.object({
  section: z
    .string({ error: 'Section is required' })
    .nonempty({ error: 'Section is required' }),
  room: z
    .string({ error: 'Room is required' })
    .nonempty({ error: 'Room is required' }),
  /** References a LightingTypeEntry by its `id` field. */
  fixtureType: z.string().optional(),
  fixtureQuantity: z.coerce.number().optional(),
  ceilingHeight: CeilingHeightSchema.optional(),
  surfaceType: SurfaceTypeSchema.optional(),
  controls: ControlsSchema.optional(),
  operationHoursPerDay: z.coerce.number().optional(),
  operationDaysPerWeek: z.coerce.number().optional(),
  comments: z.string().optional(),
});
export type AuditLightingCountFormEntry = z.infer<
  typeof AuditLightingCountFormEntrySchema
>;

export const AuditLightingCountFormSchema = z.object({
  type: z.literal('lighting-count'),
  entries: z.array(AuditLightingCountFormEntrySchema),
});
export type AuditLightingCountForm = z.infer<
  typeof AuditLightingCountFormSchema
>;
